import { Navigate, Outlet } from 'react-router';
import { useAuth } from '@/shared/hooks/useAuth';
import { ROUTES } from '@/shared/config/routes';

/**
 * AuthRedirect — wraps auth pages (login, signup, forgot-password).
 * If the user is already authenticated, redirects to dashboard.
 */
export function AuthRedirect() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
